import { render, staticRenderFns } from "./PrioridadeDashboard.vue?vue&type=template&id=fd05220a&scoped=true"
import script from "./PrioridadeDashboard.vue?vue&type=script&lang=js"
export * from "./PrioridadeDashboard.vue?vue&type=script&lang=js"
import style0 from "./PrioridadeDashboard.vue?vue&type=style&index=0&id=fd05220a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd05220a",
  null
  
)

export default component.exports